



















































import Vue from "vue"
import {mapMutations, mapState} from "vuex"

export default Vue.extend({

  name: "sidebar",

  data: () => ({
    
    ithread: -1,
    timeout: "",
    
    homehref: "/",
    links:[
      {
        logged: false,
        title: "Login",
        icon: "mdi-login",
        href:"/login"
      },
      {
        logged: true,
        title: "IP Requests",
        icon: "mdi-arrow-left-right",
        href:"/ip-request"
      },
      {
        logged: true,
        title: "IP Blacklist",
        icon: "mdi-clipboard-text",
        href:"/ip-blacklist"
      },      
      {
        logged: true,
        title: "Log out",
        icon: "mdi-exit-run",
        href:"/logout"
      },      
    ]
  }),

  mounted(){
    console.log("sidebar mounted")
  },

  computed:{
    mdldrawer: {
      get() {
        console.log("mdldrawer.get.store.state.sidebar:",this.$store.state.sidebar)
        return this.$store.state.sidebar
      },

      set (isvisible) {
        console.log("mdldrawer.set.isvisible:",isvisible)
        this.$store.commit('set_sidebar',isvisible)
      }
    },
    ...mapState(["islogged","sidebar"]),
    get_links(){
      if(this.islogged)
        return this.links.filter(link => link.logged)
      
      return this.links.filter(link => !link.logged)
      
    },
    get_now(){
      (this as any).set_now()
      return this.timeout
    }

  },

  methods:{
    set_now(){
      this.ithread = setInterval(()=>{
        this.timeout = (this as any).moment().format('YYYY-MM-DD H:m:ss')
        //console.log("navbar.set_now clearing interval: ",this.ithread)
        clearInterval(this.ithread)
      },1000)
      //console.log("navbar.set_now.this.ithread",this.ithread)
    } 
  }
})
